export default class navLinks {
    static navLinks() {
        return {
            links: [
                {
                    path: 'https://ironshorepharma.com/jornay-pm-label',
                    target: '_blank',
                    title: 'full prescribing information'
                },
                // {
                //     path: '/Price_Disclosure',
                //     title: 'pricing information'
                // },
                {
                    path: 'https://www.jornaypm.com',
                    target: '_blank',
                    title: 'visit patient site'
                }
            ]
        }
    }
    static navHeader() {
        return {
            nav: [
                {
                    title: 'Home',
                    path: '/',
                    dataAtrr: 'header'
                },
                {
                    title: 'educational ' + '<br> ' + 'videos',
                    path: '/videos',
                    dataAtrr: 'header'
                },
                {
                    title: 'visit patient site',
                    path: 'https://www.jornaypm.com/',
                    dataAtrr: 'header',
                    class: 'mobile-link'
                },
                // {
                //     title: 'pricing information',
                //     path: '/Price_Disclosure',
                //     dataAtrr: 'header',
                //     class: 'mobile-link'
                // },
            ]
        }
    }

    static navFooter() {
        return {
            nav: [
                {
                    title: 'privacy policy',
                    path: 'https://www.ironshorepharma.com/privacy.html',
                },
                {
                    title: 'contact us',
                    path: 'https://www.ironshorepharma.com/contactus.html',
                },
                {
                    title: 'about ironshore',
                    path: 'https://www.ironshorepharma.com/about-IPA.html',
                },
                {
                    title: 'full prescribing information',
                    path: 'https://ironshorepharma.com/jornay-pm-label',
                },
            ]
        }
    }
}